import React from 'react'
import { Container, SwiperCarousel } from '../../../components'
import { Link } from 'react-router-dom'
import { Card as CardDefault } from '../../resource/components'
import { CardExpert } from '../../resource/components'
import { viewportBreakpoint } from '../../../utils'
import dataDefault from '../../../database/resources.json'

const RelatedResources = ({type}) => {
  const [data, setData] = React.useState(dataDefault.slice(0, 8))

  React.useEffect(() => {
    if(type === 'expert'){
      const experts = dataDefault.filter(d => d.category === 'Expert')
      setData(experts.slice(0, 6))
    }
  }, [type])

  return (
    <Container className="py-10 lg:py-20 overflow-x-hidden">
      <p className="text-center lg:text-left lg:text-2xl mb-5 lg:mb-10 font-bold">
        Related Resources
      </p>

      {/* Cards */}
      <div className="-mx-2 lg:-mx-4 text-gray-900">
        <SwiperCarousel breakpoints={{
          [viewportBreakpoint.desktop] : {
            slidesPerView: type === 'expert' ? 4 : 6
          }
        }}>
          {
            data.map((d, index) => (
              <div className="w-1/2 lg:w-1/6 px-2 lg:px-4 mb-4 lg:mb-8" key={index}>
                <Link to={`/resource/detail/${d.id}${d.special ? '?special' : ''}`}>
                  {
                    (d.type === 'expert' || d.category === 'Expert') &&
                    <CardExpert data={d} short embed/>
                  }
                  {
                    (d.type !== 'expert' && d.category !== 'Expert') &&
                    <CardDefault data={d} short embed/>
                  }
                </Link>
              </div>
            ))
          }
        </SwiperCarousel>
      </div>
    </Container>
  )
}

export { RelatedResources }